import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Footer from "../components/footer";
import BlogDetailsContent from "./BlogDetailsContent";
import BlogNav from "./BlogNav";

const BlogDetails = () => {
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");
  }, []); 

  return (
    <div>
      <BlogNav/>
      <div className='page-margin'>
        <CustomBreadcrumb items={"Blog details"} />
        {/* Blog Section starts */}
        <section className='blog-page blog-details'>
          <Container>
            <Row>
              <Col sm='12'>
                  <BlogDetailsContent/>
              </Col>
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        {/* Blog Section End */}

        {/* Footer Section start */}
        <Footer />
        {/* Footer Section End */}
      </div>
    </div>
  );
};

export default BlogDetails;
